/**
 *
 * CustomListForm
 *
 */


// var sw = require('./../sw');
var ShapewaysFormView = require('./ShapewaysFormView');
var _ = require('underscore');
var $ = require('./../../sw-jquery/sw-jquery');

var CustomListForm = ShapewaysFormView.extend({

  events: {
    'click [data-sw-custom-list-add-item]': 'addItem',
    'click [data-sw-custom-list-delete-item]': 'deleteItem',
    'submit': 'onSubmit'
  },

  initialize: function initialize(options) {
    this.addItemPreSubmit = options.addItemPreSubmit;
    this.onSubmitSuccessCallback = options.onSubmitSuccessCallback;
    this.addItemSuccessCallback = options.addItemSuccessCallback;
    this.onSubmitErrorCallback = options.onSubmitErrorCallback;
    this.addItemErrorCallback = options.addItemErrorCallback;
    this.deleteItemSuccessCallback = options.deleteItemSuccessCallback;
    this.deleteItemFailCallback = options.deleteItemFailCallback;
  },

  deleteItem: function(e) {
    e.preventDefault();

    var $target = $(e.target);

    $.ajax({
      method: 'POST',
      url: $target.attr('href'),
      data: {
        listId: $target.data('swCustomListDeleteItem')
      },
      dataType: 'json',
      success: _.bind(function(data) {

        if (data.status !== 'success') {
          if(_.isFunction(this.deleteItemFailCallback)) {
          this.deleteItemFailCallback(data);
        }
        }

        if(_.isFunction(this.deleteItemSuccessCallback)) {
          this.deleteItemSuccessCallback(data);
        }
      }, this)
    });
  },

  addItem: function(e) {
    e.preventDefault();

    var $target = $(e.target);

    if(_.isFunction(this.addItemPreSubmit)) {
      this.addItemPreSubmit();
    }

    $.ajax({
      method: 'POST',
      url: $target.attr('href'),
      dataType: 'json',
      success: _.bind(function(data) {

        if (data.result !== 'success') {
          if(_.isFunction(this.addItemErrorCallback)) {
            this.addItemErrorCallback(data);
          }
          return;
        }

        if(_.isFunction(this.addItemSuccessCallback)) {
          this.addItemSuccessCallback(data);
        }

        this.replaceWith(data.data.html);
      }, this)
    });
  },

  onSubmit: function(e) {
    e.preventDefault();

    var $form = this.$('form');

    this.inlinePost({
      $form: $form,
      dataType: 'json'
    }).done(_.bind(function(data) {

      if (data.status !== 'success') {
        if(_.isFunction(this.onSubmitErrorCallback)) {
          this.onSubmitErrorCallback(data);
        }
        return;
      }

      if(_.isFunction(this.onSubmitSuccessCallback)) {
        this.onSubmitSuccessCallback(data);
      }

      if(data.html) {
        this.replaceWith(data.html);
      }

    },this));
  }

});

module.exports = CustomListForm;
